module.exports = __webpack_public_path__ + "static/img/iconimg.a177555b.png";